import "@/App.css";
import { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import { 
  Menu, 
  X, 
  Dumbbell, 
  Users, 
  Apple, 
  Heart,
  ChevronRight,
  MapPin,
  Phone,
  Mail,
  Clock,
  Instagram,
  Facebook,
  CheckCircle,
  Star,
  Flame,
  Sparkles,
  Globe,
  Download
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";

// External URL for "Rejoins-nous" button - SimplyBook
const EXTERNAL_JOIN_URL = "https://lnfit.simplybook.it/v2/?_gl=1*1dvx7s8*_gcl_au*MTMzMzM5NzIyMC4xNzczOTkzNjMyLjk1NzY2OTM1NS4xNzczOTkzNjM3LjE3NzM5OTM2Mzc.*_ga*OTE5ODI2NTk3LjE3NzM5OTM2MzI.*_ga_DF4Z49WJND*czE3NzM5OTM2MjkkbzEkZzEkdDE3NzM5OTQzOTgkajYwJGwwJGg0OTY2ODc4Ng..#book";

// TikTok link
const TIKTOK_URL = "https://www.tiktok.com/@ln_fit?is_from_webapp=1&sender_device=pc";

// LnFit Logo - New logo with black background
const LOGO_URL = "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/36wwd3tw_WhatsApp%20Image%202026-04-10%20at%2008.47.09.jpeg";

const LnFitLogo = ({ className = "h-16" }) => (
  <img 
    src={LOGO_URL} 
    alt="LnFit Studio - Train Hard Glow Hard" 
    className={`${className} w-auto object-contain rounded-full`}
  />
);

// TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

// Hero images - Studio LnFit carousel
const HERO_IMAGES = [
  "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/hpg56qvw_image1.JPG",
  "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/yhl0cngi_image2.JPG",
  "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/s01sptqv_image3.JPG",
];

// Images - Real coach photos
const IMAGES = {
  coachLucie: "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/qy9kt273_image%20lucie.JPG",
  coachAmy: "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/a2ucwp72_image%20Amy.JPG",
  coachScheera: "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/i7ybn5l6_image%20scheera.JPG",
  pilates: "https://images.unsplash.com/photo-1763403921315-f2ef8697199f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx3b21lbiUyMGZpdG5lc3MlMjBwaWxhdGVzJTIwd29ya291dCUyMGdyb3VwJTIwY2xhc3N8ZW58MHx8fHwxNzc1NzcwNDkwfDA&ixlib=rb-4.1.0&q=85",
  coaching1v1: "https://images.unsplash.com/photo-1571732154690-f6d1c3e5178a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHx0d28lMjB3b21lbiUyMHBlcnNvbmFsJTIwdHJhaW5pbmclMjBzZXNzaW9uJTIwZ3ltJTIwd29ya291dHxlbnwwfHx8fDE3NzU4MjUxODZ8MA&ixlib=rb-4.1.0&q=85",
  coachingGroup: "https://images.pexels.com/photos/3768697/pexels-photo-3768697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Instagram URL
const INSTAGRAM_URL = "https://www.instagram.com/lnf_it?igsh=b3U5bmVwaGh2MGto&utm_source=qr";

// Pricing URLs - All point to memberships page
const PRICING_URLS = {
  standard: "https://lnfit.simplybook.it/v2/#membership",
  premium: "https://lnfit.simplybook.it/v2/#membership",
  vip: "https://lnfit.simplybook.it/v2/#membership",
};

// Contact Info
const CONTACT_INFO = {
  address: "268 boulevard saint-joseph, Gatineau QC J8Y3X9",
  phone: "+1 (819) 576-1953",
  email: "lnfit2142@gmail.com",
  hours: "Lun-Sam : 6h30 - 22h00 | Dim : 10h00 - 17h00",
};

// Translations
const translations = {
  fr: {
    nav: {
      accueil: "Accueil",
      services: "Services",
      coachs: "Coachs",
      tarifs: "Tarifs",
      contact: "Contact",
    },
    hero: {
      badge: "Studio de Coaching Féminin & Pilates",
      title1: "Transforme ton corps,",
      title2: "libère ton potentiel",
      description: "Coaching personnalisé pour la perte de poids, prise de masse, remise en forme et pilates. Sessions individuelles ou en groupe, réservées aux femmes.",
      cta: "Réserve ta place",
      discover: "Découvrir nos services",
    },
    services: {
      badge: "Nos Services",
      title1: "Des programmes adaptés",
      title2: "à chaque objectif",
      description: "Que vous souhaitiez perdre du poids, gagner en masse musculaire ou améliorer votre bien-être, nous avons le programme qu'il vous faut.",
      coaching1v1: { title: "Coaching personnalisé", desc: "Des séances adaptées à votre niveau et à vos objectifs, avec un accompagnement motivant et structuré." },
      group: { title: "Séances encadrées", desc: "Des entraînements guidés du début à la fin, dans un cadre sécurisant et dynamique." },
      nutrition: { title: "Activités variées", desc: "Des sessions ponctuelles pour diversifier votre routine : pilates, yoga, danse, et plus encore." },
      pilates: { title: "Accompagnement global", desc: "Bien plus que du sport : plans alimentaires, conseils, discipline et mindset pour des résultats durables." },
    },
    coaches: {
      badge: "Notre Équipe",
      title1: "Des coachs passionnées",
      title2: "à votre service",
      description: "Notre équipe de professionnelles certifiées vous accompagne dans l'atteinte de vos objectifs.",
    },
    pricing: {
      badge: "Nos Tarifs",
      title1: "Choisissez l'abonnement",
      title2: "qui vous correspond",
      description: "Des formules flexibles pour s'adapter à vos besoins et votre budget.",
      popular: "Le plus populaire",
      choose: "Choisir ce plan",
      plans: {
        groupe: { name: "Forfait Groupe", desc: "Parfait pour débuter", features: ["3 séances par semaine", "Plan alimentaire de base", "Cours en petit groupe (max. 3 personnes)", "Suivi de la pesée chaque semaine", "Prise de mesures toutes les 2 semaines"] },
        intensif: { name: "Forfait Groupe Intensif", desc: "Pour aller plus loin", features: ["4 séances par semaine", "Plan alimentaire sur 2 semaines", "Cours en groupe motivant", "Suivi de la pesée", "Prise de mesures toutes les 2 semaines", "Suivi des repas"] },
        premium: { name: "Forfait Premium", desc: "L'expérience complète", features: ["Coaching individuel personnalisé", "Plan alimentaire sur mesure (selon tes besoins)", "Séances à la demande (jusqu'à 5 séances)", "Suivi de la pesée", "Prise de mesures à la demande"] },
      }
    },
    contact: {
      badge: "Contact",
      title1: "Prête à commencer",
      title2: "ta transformation ?",
      description: "Contactez-nous dès aujourd'hui et découvrez comment nous pouvons vous aider à atteindre vos objectifs.",
      address: "Adresse",
      phone: "Téléphone",
      email: "Email",
      hours: "Horaires des cours",
      hoursValue: "Lundi au vendredi : 10 h | 11 h 30 | 18 h | 19 h",
      openingHours: "Heures d'ouverture",
      openingHoursValue: "De 10 h à 13 h  |  De 16 h à 20 h",
      ctaTitle: "Commence ta transformation",
      ctaDesc: "Rejoins notre communauté de femmes motivées et atteins tes objectifs avec nos coachs dédiées.",
      ctaBtn: "Réserve ta place dès maintenant",
    },
    footer: {
      desc: "Un espace 100 % féminin dédié à votre bien-être, votre progression et votre confiance.",
      quickLinks: "Liens Rapides",
      servicesTitle: "Services",
      rights: "Tous droits réservés.",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
    }
  },
  en: {
    nav: {
      accueil: "Home",
      services: "Services",
      coachs: "Coaches",
      tarifs: "Pricing",
      contact: "Contact",
    },
    hero: {
      badge: "Women's Coaching Studio & Pilates",
      title1: "Transform your body,",
      title2: "unlock your potential",
      description: "Personalized coaching for weight loss, muscle gain, fitness and pilates. Individual or group sessions, dedicated to women.",
      cta: "Book your spot",
      discover: "Discover our services",
    },
    services: {
      badge: "Our Services",
      title1: "Programs tailored",
      title2: "to every goal",
      description: "Whether you want to lose weight, build muscle or improve your well-being, we have the program for you.",
      coaching1v1: { title: "Personalized Coaching", desc: "Sessions tailored to your level and goals, with motivating and structured support." },
      group: { title: "Guided Sessions", desc: "Workouts guided from start to finish, in a safe and dynamic environment." },
      nutrition: { title: "Varied Activities", desc: "One-time sessions to diversify your routine: pilates, yoga, dance, and more." },
      pilates: { title: "Complete Support", desc: "More than just sport: meal plans, advice, discipline and mindset for lasting results." },
    },
    coaches: {
      badge: "Our Team",
      title1: "Passionate coaches",
      title2: "at your service",
      description: "Our team of certified professionals supports you in achieving your goals.",
    },
    pricing: {
      badge: "Our Prices",
      title1: "Choose the plan",
      title2: "that fits you",
      description: "Flexible plans to suit your needs and budget.",
      popular: "Most popular",
      choose: "Choose this plan",
      plans: {
        groupe: { name: "Group Plan", desc: "Perfect to start", features: ["3 sessions per week", "Basic meal plan", "Small group classes (max. 3 people)", "Weekly weigh-in", "Measurements every 2 weeks"] },
        intensif: { name: "Intensive Group Plan", desc: "Go further", features: ["4 sessions per week", "2-week meal plan", "Motivating group classes", "Weigh-in tracking", "Measurements every 2 weeks", "Meal tracking"] },
        premium: { name: "Premium Plan", desc: "The complete experience", features: ["Personalized individual coaching", "Custom meal plan (based on your needs)", "On-demand sessions (up to 5 sessions)", "Weigh-in tracking", "Measurements on demand"] },
      }
    },
    contact: {
      badge: "Contact",
      title1: "Ready to start",
      title2: "your transformation?",
      description: "Contact us today and discover how we can help you achieve your goals.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Class Schedule",
      hoursValue: "Monday to Friday: 10 AM | 11:30 AM | 6 PM | 7 PM",
      openingHours: "Opening Hours",
      openingHoursValue: "10 AM to 1 PM  |  4 PM to 8 PM",
      ctaTitle: "Start your transformation",
      ctaDesc: "Join our community of motivated women and reach your goals with our dedicated coaches.",
      ctaBtn: "Book your spot now",
    },
    footer: {
      desc: "A 100% women's space dedicated to your well-being, progress and confidence.",
      quickLinks: "Quick Links",
      servicesTitle: "Services",
      rights: "All rights reserved.",
      legal: "Legal Notice",
      privacy: "Privacy Policy",
    }
  }
};

// Header Component
const Header = ({ lang, setLang, t }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: t.nav.accueil, href: "#hero" },
    { name: t.nav.services, href: "#services" },
    { name: t.nav.coachs, href: "#coaches" },
    { name: t.nav.tarifs, href: "#pricing" },
    { name: lang === 'fr' ? "Comment ça marche ?" : "How It Works?", href: "#how-it-works" },
    { name: t.nav.contact, href: "#contact" },
  ];

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-lg shadow-violet-500/10" : "bg-violet-500"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#hero" data-testid="logo" className="flex items-center">
            <LnFitLogo className="h-14 w-auto" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                data-testid={`nav-${link.name.toLowerCase()}`}
                className={`nav-link-light font-heading text-sm font-medium tracking-wide transition-colors ${
                  isScrolled
                    ? "text-black/90 hover:text-violet-500"
                    : "text-white hover:text-white/70"
                }`}
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Button + Language Switcher */}
          <div className="hidden md:flex items-center gap-4">
            <a href={EXTERNAL_JOIN_URL} target="_blank" rel="noopener noreferrer">
              <Button
                data-testid="header-join-btn"
                className={`font-heading font-semibold rounded-full px-6 py-2 transition-colors ${
                  isScrolled
                    ? "bg-violet-500 hover:bg-violet-600 text-white"
                    : "bg-white hover:bg-white/90 text-violet-600"
                }`}
              >
                {t.hero.cta}
              </Button>
            </a>
            
            {/* Language Switcher */}
            <button
              data-testid="lang-switcher"
              onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')}
              className={`flex items-center gap-1 font-heading text-sm font-medium border rounded-full px-3 py-1.5 transition-colors ${
                isScrolled
                  ? "text-black/90 hover:text-violet-500 border-black/30 hover:border-violet-500"
                  : "text-white hover:text-white/70 border-white/60 hover:border-white"
              }`}
            >
              <Globe className="h-4 w-4" />
              <span>{lang === 'fr' ? 'EN' : 'FR'}</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            className={`md:hidden p-2 ${isScrolled ? "text-black" : "text-white"}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div
            data-testid="mobile-menu"
            className={`md:hidden absolute top-20 left-0 right-0 backdrop-blur-sm py-6 px-4 mobile-menu border-t ${
              isScrolled ? "bg-white/95 border-black/10" : "bg-violet-500 border-white/20"
            }`}
          >
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className={`font-heading text-lg py-2 ${
                    isScrolled ? "text-black/90 hover:text-violet-500" : "text-white hover:text-white/70"
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <div className="flex items-center gap-4 mt-4">
                <a href={EXTERNAL_JOIN_URL} target="_blank" rel="noopener noreferrer" className="flex-1">
                  <Button
                    data-testid="mobile-join-btn"
                    className={`font-heading font-semibold rounded-full w-full ${
                      isScrolled
                        ? "bg-violet-500 hover:bg-violet-600 text-white"
                        : "bg-white hover:bg-white/90 text-violet-600"
                    }`}
                  >
                    {t.hero.cta}
                  </Button>
                </a>
                <button
                  data-testid="mobile-lang-switcher"
                  onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')}
                  className={`flex items-center gap-1 font-heading text-sm border-2 rounded-full px-4 py-2 ${
                    isScrolled ? "text-black border-black/50" : "text-white border-white/70"
                  }`}
                >
                  <Globe className="h-4 w-4" />
                  <span className="font-bold">{lang === 'fr' ? 'EN' : 'FR'}</span>
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

// Hero Section with Image (diverse women)
// Hero Section with Image Carousel
const HeroSection = ({ t }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % HERO_IMAGES.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Images Carousel */}
      {HERO_IMAGES.map((img, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
            idx === currentImageIndex ? "opacity-100" : "opacity-0"
          }`}
          style={{ backgroundImage: `url(${img})` }}
          data-testid={`hero-background-${idx}`}
        />
      ))}
      
      {/* Violet Gradient Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        <div className="section-animate">
          <Badge 
            data-testid="hero-badge"
            className="mb-6 bg-white/20 text-white border-white/30 px-4 py-1 backdrop-blur-sm font-heading"
          >
            {t.hero.badge}
          </Badge>
        </div>
        
        <h1 
          data-testid="hero-title"
          className="section-animate section-animate-delay-1 font-heading text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium text-white tracking-tighter mb-6"
        >
          {t.hero.title1}<br />
          <span className="text-gradient font-bold">{t.hero.title2}</span>
        </h1>
        
        <p 
          data-testid="hero-description"
          className="section-animate section-animate-delay-2 font-heading text-lg sm:text-xl text-white/90 max-w-2xl mx-auto mb-10"
        >
          {t.hero.description}
        </p>
        
        <div className="section-animate section-animate-delay-3 flex flex-col sm:flex-row gap-4 justify-center">
          <a href={EXTERNAL_JOIN_URL} target="_blank" rel="noopener noreferrer">
            <Button
              data-testid="hero-join-btn"
              size="lg"
              className="btn-primary font-heading font-semibold rounded-full px-10 py-6 text-lg"
            >
              {t.hero.cta}
              <ChevronRight className="ml-2 h-5 w-5" />
            </Button>
          </a>
          <a href="#services">
            <Button
              data-testid="hero-discover-btn"
              variant="outline"
              size="lg"
              className="btn-secondary font-heading font-semibold rounded-full px-10 py-6 text-lg"
            >
              {t.hero.discover}
            </Button>
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

// Marquee Section
const MarqueeSection = () => {
  const services = [
    "PERTE DE POIDS",
    "PRISE DE MASSE",
    "PERTE DE VENTRE",
    "REMISE EN FORME",
    "PLAN ALIMENTAIRE",
    "PILATES",
  ];

  return (
    <section data-testid="marquee-section" className="py-6 bg-white overflow-hidden">
      <Marquee gradient={false} speed={50} className="overflow-hidden">
        {services.map((service, index) => (
          <span
            key={index}
            className="font-heading text-xl sm:text-2xl font-bold text-violet-500 mx-8 tracking-wider"
          >
            {service} <Star className="inline h-4 w-4 mx-2 fill-violet-500 text-violet-500" />
          </span>
        ))}
        {services.map((service, index) => (
          <span
            key={`dup-${index}`}
            className="font-heading text-xl sm:text-2xl font-bold text-violet-500 mx-8 tracking-wider"
          >
            {service} <Star className="inline h-4 w-4 mx-2 fill-violet-500 text-violet-500" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

// Services Section (Bento Grid)
const ServicesSection = ({ t }) => {
  const services = [
    {
      id: "coaching-perso",
      title: t.services.coaching1v1.title,
      description: t.services.coaching1v1.desc,
      icon: <Dumbbell className="h-8 w-8" />,
      image: null,
      span: "",
    },
    {
      id: "seances-encadrees",
      title: t.services.group.title,
      description: t.services.group.desc,
      icon: <Users className="h-8 w-8" />,
      image: null,
      span: "",
    },
    {
      id: "activites-variees",
      title: t.services.nutrition.title,
      description: t.services.nutrition.desc,
      icon: <Star className="h-8 w-8" />,
      image: null,
      span: "",
    },
    {
      id: "accompagnement-global",
      title: t.services.pilates.title,
      description: t.services.pilates.desc,
      icon: <Sparkles className="h-8 w-8" />,
      image: null,
      span: "",
    },
  ];

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-violet-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-white/20 text-white border-white/30 px-4 py-1 font-heading">
            {t.services.badge}
          </Badge>
          <h2 
            data-testid="services-title"
            className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-white tracking-tighter mb-4"
          >
            {t.services.title1}<br />
            <span className="font-bold">{t.services.title2}</span>
          </h2>
          <p className="font-heading text-base sm:text-lg text-white/80 max-w-2xl mx-auto">
            {t.services.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <Card
              key={service.id}
              data-testid={`service-${service.id}`}
              className={`bento-item bg-violet-500/50 border border-white/20 overflow-hidden card-hover backdrop-blur-sm ${service.span}`}
            >
              {service.image ? (
                <div className="relative h-64 md:h-80 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-violet-700 via-violet-600/60 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                    <div className="text-white mb-3">{service.icon}</div>
                    <h3 className="font-heading text-xl sm:text-2xl font-bold text-white mb-2">
                      {service.title}
                    </h3>
                    <p className="font-heading text-white/90">{service.description}</p>
                  </div>
                </div>
              ) : (
                <CardContent className="p-6 md:p-8 h-full flex flex-col justify-between min-h-[200px]">
                  <div className="text-white mb-4">{service.icon}</div>
                  <div>
                    <h3 className="font-heading text-xl sm:text-2xl font-bold text-white mb-2">
                      {service.title}
                    </h3>
                    <p className="font-heading text-white/90">{service.description}</p>
                  </div>
                </CardContent>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

// Coaches Section
const CoachesSection = ({ t }) => {
  const isEnglish = t.coaches.description.includes("certified");
  
  const coaches = [
    {
      id: "coach-1",
      name: "Lucie Ngono",
      description: isEnglish 
        ? "Founder of the studio, she created this space with a clear vision: to offer women much more than just a workout. Through a structured method and a human approach, she accompanies each client in transforming herself, both physically and mentally. Passionate and committed, she has trained a team of coaches according to her own standards to guarantee a unique experience, based on progression, confidence and self-surpassing. Her goal: to create an environment where every woman feels at her place, supported and proud of her evolution."
        : "Fondatrice du studio, elle a créé cet espace avec une vision claire : offrir aux femmes bien plus qu'un simple entraînement. À travers une méthode structurée et une approche humaine, elle accompagne chaque cliente à se transformer, autant physiquement que mentalement. Passionnée et engagée, elle a formé une équipe de coachs selon ses propres standards afin de garantir une expérience unique, basée sur la progression, la confiance et le dépassement de soi. Son objectif : créer un environnement où chaque femme se sent à sa place, soutenue et fière de son évolution.",
      image: IMAGES.coachLucie,
    },
    {
      id: "coach-2",
      name: "Aminata Traoré",
      description: isEnglish 
        ? "Amy brings contagious energy to every session. Always smiling and attentive, she pushes you to give your best in a positive and motivating atmosphere. Having experienced a transformation herself, with her, every workout becomes a moment you look forward to."
        : "Amy apporte une énergie contagieuse à chaque séance. Toujours souriante et à l'écoute, elle te pousse à donner le meilleur de toi-même dans une ambiance positive et motivante. Ayant elle-même vécu une transformation, avec elle, chaque entraînement devient un moment que tu attends.",
      image: IMAGES.coachAmy,
    },
    {
      id: "coach-3",
      name: "Scheera Kouame",
      description: isEnglish 
        ? "Scheera embodies discipline and consistency. She understands every step of the journey and allows you to reveal the best version of yourself. Today, she helps you surpass yourself, at your own pace, while building real self-confidence."
        : "Scheera incarne la discipline et la constance. Elle comprend chaque étape du parcours et te permet de révéler la meilleure version de toi. Aujourd'hui, elle t'aide à te dépasser, à ton rythme, tout en construisant une vraie confiance en toi.",
      image: IMAGES.coachScheera,
    },
  ];

  return (
    <section id="coaches" data-testid="coaches-section" className="py-24 md:py-32 bg-violet-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-white/20 text-white border-white/30 px-4 py-1 font-heading">
            {t.coaches.badge}
          </Badge>
          <h2 
            data-testid="coaches-title"
            className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-white tracking-tighter mb-4"
          >
            {t.coaches.title1}<br />
            <span className="font-bold">{t.coaches.title2}</span>
          </h2>
          <p className="font-heading text-base sm:text-lg text-white/80 max-w-2xl mx-auto">
            {t.coaches.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {coaches.map((coach) => (
            <Card
              key={coach.id}
              data-testid={coach.id}
              className="coach-card bg-violet-600/50 border border-white/20 overflow-hidden group backdrop-blur-sm"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={coach.image}
                  alt={coach.name}
                  className="w-full h-full object-cover transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-violet-700 via-transparent to-transparent" />
              </div>
              <CardContent className="p-6">
                <h3 className="font-heading text-xl sm:text-2xl font-bold text-white mb-2">
                  {coach.name}
                </h3>
                <p className="font-heading text-white/90">{coach.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

// Pricing Section
const PricingSection = ({ t }) => {
  const isEnglish = t.pricing.choose.includes("Choose");
  
  const plans = [
    {
      id: "standard",
      name: isEnglish ? "Standard Group Plan" : "Forfait Standard Groupe",
      price: "75",
      period: isEnglish ? "/ 2 weeks" : "/ 2 semaines",
      description: isEnglish ? "Ideal to start and get moving" : "Idéal pour commencer et te mettre en mouvement",
      features: isEnglish ? [
        "3 sessions/week in group with coach",
        "Meal plan included",
        "Weekly weigh-in tracking",
        "Detailed progress report",
        "Access to events (by reservation)",
      ] : [
        "3 séances/semaine en groupe avec coach",
        "Plan alimentaire inclus",
        "Suivi de ta pesée chaque semaine",
        "Rapport détaillé de tes progrès",
        "Accès aux événements (sur réservation)",
      ],
      popular: false,
      emoji: "💪",
      paymentUrl: PRICING_URLS.standard,
    },
    {
      id: "premium",
      name: isEnglish ? "Premium Group Plan" : "Forfait Premium Groupe",
      price: "95",
      period: isEnglish ? "/ 2 weeks" : "/ 2 semaines",
      description: isEnglish ? "Perfect for visible RESULTS faster" : "Parfait si tu veux des RÉSULTATS visibles plus rapidement",
      features: isEnglish ? [
        "4 sessions/week with coach",
        "Meal plan + personalized follow-up adjusted every 2 weeks",
        "Weekly progress tracking",
        "Complete results report",
        "Access to yoga & pilates classes 🧘‍♀️",
        "Invitations to exclusive events",
      ] : [
        "4 séances/semaine avec coach",
        "Plan alimentaire + suivi personnalisé ajusté toutes les 2 semaines",
        "Suivi de ta progression chaque semaine",
        "Rapport complet de tes résultats",
        "Accès aux cours de yoga & pilates 🧘‍♀️",
        "Invitations aux événements exclusifs",
      ],
      popular: true,
      emoji: "🔥",
      paymentUrl: PRICING_URLS.premium,
    },
    {
      id: "vip",
      name: isEnglish ? "VIP Plan" : "Forfait VIP",
      price: "375",
      period: isEnglish ? "/ 2 weeks" : "/ 2 semaines",
      description: isEnglish ? "The ultimate experience for a complete transformation" : "L'expérience ultime pour une transformation complète",
      features: isEnglish ? [
        "4 training sessions per week",
        "Personalized support tailored to your goals",
        "Option to swap one of the four sessions for a group class",
        "Regular progress tracking",
      ] : [
        "4 séances d'entraînement par semaine",
        "Un accompagnement personnalisé adapté à vos objectifs",
        "La possibilité de remplacer une des quatre séances par un cours de groupe",
        "Un suivi régulier de votre progression",
      ],
      popular: false,
      emoji: "👑",
      paymentUrl: PRICING_URLS.vip,
    },
  ];

  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 md:py-32 bg-violet-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-white/20 text-white border-white/30 px-4 py-1 font-heading">
            {t.pricing.badge}
          </Badge>
          <h2 
            data-testid="pricing-title"
            className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-white tracking-tighter mb-4"
          >
            {t.pricing.title1}<br />
            <span className="font-bold">{t.pricing.title2}</span>
          </h2>
          <p className="font-heading text-base sm:text-lg text-white/80 max-w-2xl mx-auto">
            {t.pricing.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {plans.map((plan) => (
            <Card
              key={plan.id}
              data-testid={`pricing-${plan.id}`}
              className={`relative bg-violet-600/50 border overflow-hidden transition-all duration-300 backdrop-blur-sm ${
                plan.popular
                  ? "border-white scale-105 z-10 shadow-2xl"
                  : "border-white/20 hover:border-white/40"
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 left-0 right-0 bg-white text-violet-600 text-center py-2 text-sm font-heading font-bold flex items-center justify-center gap-2">
                  <Flame className="h-4 w-4" /> {t.pricing.popular}
                </div>
              )}
              <CardHeader className={plan.popular ? "pt-12" : ""}>
                <CardTitle className="font-heading text-xl text-white font-bold flex items-center gap-2">
                  <span>{plan.emoji}</span> {plan.name}
                </CardTitle>
                <CardDescription className="font-heading text-white/80">{plan.description}</CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-5xl font-bold text-white">{plan.price}$</span>
                  <span className="font-heading text-white/80">{plan.period}</span>
                </div>
                
                <Separator className="bg-white/20" />
                
                <ul className="space-y-3">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle className="h-5 w-5 text-white flex-shrink-0 mt-0.5" />
                      <span className="font-heading text-white/90">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <a href={plan.paymentUrl} target="_blank" rel="noopener noreferrer" className="block">
                  <Button
                    data-testid={`pricing-${plan.id}-btn`}
                    className={`w-full rounded-full py-6 font-heading font-semibold ${
                      plan.popular
                        ? "btn-primary"
                        : "btn-secondary"
                    }`}
                  >
                    {t.pricing.choose}
                  </Button>
                </a>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

// PDF Guide URL
const GUIDE_PDF_URL = "https://customer-assets.emergentagent.com/job_studio-fit-portal/artifacts/emz87s22_Guide%20Utilisateur%20Client.pdf";

// How It Works Section
const HowItWorksSection = ({ t }) => {
  const isEnglish = t.pricing.choose.includes("Choose");
  
  const steps = [
    {
      number: "1",
      title: isEnglish ? "Access the booking link" : "Accède au lien de réservation",
      description: isEnglish 
        ? "Go to lnfit.simplybook.it or scan the QR code. You can also add the app to your home screen for quick access."
        : "Rends-toi sur lnfit.simplybook.it ou scanne le code QR. Tu peux aussi ajouter l'application à ton écran d'accueil pour un accès rapide.",
      icon: <Globe className="h-8 w-8" />,
    },
    {
      number: "2",
      title: isEnglish ? "Choose your plan" : "Choisis ton forfait",
      description: isEnglish
        ? "In the menu, select 'Memberships' and choose the plan that suits you: Standard, Premium or VIP."
        : "Dans le menu, sélectionne 'Memberships' et choisis le forfait qui te convient : Standard, Premium ou VIP.",
      icon: <CheckCircle className="h-8 w-8" />,
    },
    {
      number: "3",
      title: isEnglish ? "Create your account" : "Crée ton compte",
      description: isEnglish
        ? "Sign in with your Google or Facebook account, or create a new account with your email."
        : "Connecte-toi avec ton compte Google ou Facebook, ou crée un nouveau compte avec ton email.",
      icon: <Users className="h-8 w-8" />,
    },
    {
      number: "4",
      title: isEnglish ? "Complete your payment" : "Finalise ton paiement",
      description: isEnglish
        ? "Review your order summary and proceed to secure payment. You'll receive a confirmation right away!"
        : "Vérifie le récapitulatif de ta commande et procède au paiement sécurisé. Tu recevras une confirmation immédiatement !",
      icon: <Sparkles className="h-8 w-8" />,
    },
    {
      number: "5",
      title: isEnglish ? "Book your sessions" : "Réserve tes séances",
      description: isEnglish
        ? "Once subscribed, book your sessions according to your schedule. Let's go, your transformation begins!"
        : "Une fois abonnée, réserve tes séances selon ton horaire. C'est parti, ta transformation commence !",
      icon: <Dumbbell className="h-8 w-8" />,
    },
  ];

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 md:py-24 bg-violet-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-white/20 text-white border-white/30 px-4 py-1 font-heading">
            {isEnglish ? "How It Works" : "Comment ça marche ?"}
          </Badge>
          <h2 
            data-testid="how-it-works-title"
            className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-white tracking-tighter mb-4"
          >
            {isEnglish ? "Get started in" : "Commence en"}<br />
            <span className="font-bold">{isEnglish ? "5 simple steps" : "5 étapes simples"}</span>
          </h2>
          <p className="font-heading text-base sm:text-lg text-white/80 max-w-2xl mx-auto">
            {isEnglish 
              ? "Joining LnFit Studio is quick and easy. Follow these steps and start your transformation today!"
              : "Rejoindre LnFit Studio est rapide et facile. Suis ces étapes et commence ta transformation dès aujourd'hui !"}
          </p>
          
          {/* Download Guide PDF - Prominent at top */}
          <div className="mt-8 p-6 bg-white/10 rounded-2xl border border-white/20 backdrop-blur-sm max-w-md mx-auto">
            <p className="font-heading text-white mb-4 text-center">
              {isEnglish 
                ? "📄 Download the complete guide to follow the steps easily:"
                : "📄 Télécharge le guide complet pour suivre les étapes facilement :"}
            </p>
            <a 
              href={GUIDE_PDF_URL} 
              download="Guide Utilisateur Client.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              <Button
                data-testid="download-guide-top-btn"
                className="w-full bg-white hover:bg-gray-100 text-violet-600 font-heading font-bold rounded-full px-6 py-4 text-base flex items-center justify-center gap-2 transition-colors"
              >
                <Download className="h-5 w-5" />
                {isEnglish ? "Download Guide (PDF)" : "Télécharger le guide (PDF)"}
              </Button>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {steps.map((step, index) => (
            <div
              key={step.number}
              data-testid={`step-${step.number}`}
              className="relative bg-violet-600/50 border border-white/20 rounded-2xl p-6 backdrop-blur-sm text-center"
            >
              {/* Step number */}
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 bg-white text-violet-600 rounded-full flex items-center justify-center font-heading font-bold text-lg">
                {step.number}
              </div>
              
              {/* Icon */}
              <div className="text-white mb-4 mt-4 flex justify-center">
                {step.icon}
              </div>
              
              {/* Title */}
              <h3 className="font-heading text-lg font-bold text-white mb-2">
                {step.title}
              </h3>
              
              {/* Description */}
              <p className="font-heading text-sm text-white/80">
                {step.description}
              </p>
              
              {/* Arrow to next step (not on last item) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 text-white/40">
                  <ChevronRight className="h-6 w-6" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = ({ t }) => {
  return (
    <section id="contact" data-testid="contact-section" className="py-12 md:py-16 bg-violet-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left side - Info */}
          <div>
            <Badge className="mb-4 bg-white/20 text-white border-white/30 px-4 py-1 font-heading">
              {t.contact.badge}
            </Badge>
            <h2 
              data-testid="contact-title"
              className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-white tracking-tighter mb-6"
            >
              {t.contact.title1}<br />
              <span className="font-bold">{t.contact.title2}</span>
            </h2>
            <p className="font-heading text-base sm:text-lg text-white/80 mb-8">
              {t.contact.description}
            </p>
            
            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                  <MapPin className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-heading text-white font-medium">{t.contact.address}</p>
                  <p className="font-heading text-white/80">{CONTACT_INFO.address}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                  <Phone className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-heading text-white font-medium">{t.contact.phone}</p>
                  <p className="font-heading text-white/80">{CONTACT_INFO.phone}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                  <Mail className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-heading text-white font-medium">{t.contact.email}</p>
                  <p className="font-heading text-white/80">{CONTACT_INFO.email}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm flex-shrink-0">
                  <Clock className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-heading text-white font-medium">{t.contact.hours}</p>
                  <p className="font-heading text-white/80">{t.contact.hoursValue}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm flex-shrink-0">
                  <Clock className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-heading text-white font-medium">{t.contact.openingHours}</p>
                  <p className="font-heading text-white/80">{t.contact.openingHoursValue}</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right side - CTA Card */}
          <div className="flex items-center">
            <Card className="w-full bg-violet-600/50 border border-white/20 p-8 md:p-10 backdrop-blur-sm">
              <div className="text-center">
                <Sparkles className="h-16 w-16 text-white mx-auto mb-6" />
                <h3 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-4">
                  {t.contact.ctaTitle}
                </h3>
                <p className="font-heading text-white/80 mb-8">
                  {t.contact.ctaDesc}
                </p>
                <a href={EXTERNAL_JOIN_URL} target="_blank" rel="noopener noreferrer" className="inline-block max-w-full">
                  <Button
                    data-testid="contact-join-btn"
                    size="lg"
                    className="btn-primary font-heading font-semibold rounded-full px-5 sm:px-10 py-5 sm:py-6 text-sm sm:text-lg whitespace-normal h-auto"
                  >
                    {t.contact.ctaBtn}
                    <ChevronRight className="ml-2 h-5 w-5 flex-shrink-0" />
                  </Button>
                </a>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer Component
const Footer = ({ t }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="footer-gradient py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <LnFitLogo className="h-12 w-auto" />
            </div>
            <p className="font-heading text-white/80 mb-6 max-w-sm">
              {t.footer.desc}
            </p>
            <div className="flex gap-4">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
              >
                <Instagram className="h-5 w-5 text-white" />
              </a>
              <a
                href="#"
                data-testid="social-facebook"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
              >
                <Facebook className="h-5 w-5 text-white" />
              </a>
              <a
                href={TIKTOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-tiktok"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
              >
                <TikTokIcon className="h-5 w-5 text-white" />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white font-bold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="font-heading text-white/80 hover:text-white transition-colors">{t.nav.services}</a></li>
              <li><a href="#coaches" className="font-heading text-white/80 hover:text-white transition-colors">{t.nav.coachs}</a></li>
              <li><a href="#pricing" className="font-heading text-white/80 hover:text-white transition-colors">{t.nav.tarifs}</a></li>
              <li><a href="#contact" className="font-heading text-white/80 hover:text-white transition-colors">{t.nav.contact}</a></li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="font-heading text-white font-bold mb-4">{t.footer.servicesTitle}</h4>
            <ul className="space-y-3">
              <li><span className="font-heading text-white/80">{t.services.coaching1v1.title}</span></li>
              <li><span className="font-heading text-white/80">{t.services.group.title}</span></li>
              <li><span className="font-heading text-white/80">{t.services.nutrition.title}</span></li>
              <li><span className="font-heading text-white/80">{t.services.pilates.title}</span></li>
            </ul>
          </div>
        </div>
        
        <Separator className="bg-white/20 mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-heading text-white/60 text-sm">
            © {currentYear} LnFit Studio. {t.footer.rights}
          </p>
          <div className="flex gap-6">
            <a href="#" className="font-heading text-white/60 hover:text-white/80 text-sm transition-colors">
              {t.footer.legal}
            </a>
            <a href="#" className="font-heading text-white/60 hover:text-white/80 text-sm transition-colors">
              {t.footer.privacy}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Main App Component
function App() {
  const [lang, setLang] = useState('fr');
  const t = translations[lang];

  return (
    <div className="App bg-violet-400 min-h-screen">
      <Header lang={lang} setLang={setLang} t={t} />
      <main>
        <HeroSection t={t} />
        <MarqueeSection />
        <ServicesSection t={t} />
        <CoachesSection t={t} />
        <PricingSection t={t} />
        <HowItWorksSection t={t} />
        <ContactSection t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
